import { LabelValuePairsType } from 'core/types/common';

export const DATA_FIELD_SEARCH: LabelValuePairsType = [
  {
    label: 'Exchange No',
    value: 'exchangeNumber',
    searchKeys: ['exchangeNumber'],
  },
  {
    label: 'Return No',
    value: 'returnNumber',
    searchKeys: ['orderReturn.returnNumber'],
  },
  {
    label: 'Order No',
    value: 'orderNumber',
    searchKeys: ['newOrder.orderNumber'],
  },
  {
    label: 'Original Order No',
    value: 'originalOrder',
    searchKeys: ['originalOrder.orderNumber'],
  },
  // {
  //   label: 'SO',
  //   value: 'saleOrderId',
  //   searchKeys: ['saleOrderId'],
  // },
  // {
  //   label: 'SKU',
  //   value: 'sku',
  //   searchKeys: ['sku'],
  // },
  // {
  //   label: 'Shipping Phone',
  //   value: 'customerPhone',
  //   searchKeys: ['phone'],
  // },
  // {
  //   label: 'Email',
  //   value: 'email',
  //   searchKeys: ['email'],
  // },
  // {
  //   label: 'Customer name',
  //   value: 'customerName',
  //   searchKeys: ['customerName'],
  // },
  // {
  //   label: 'Shipping No',
  //   value: 'deliveryCode',
  //   searchKeys: ['deliveryCode'],
  // },
];
